module.exports = __webpack_public_path__ + "img/mes-scene-injection.697d1116.jpg";